import { render, staticRenderFns } from "./addSpecDlg.vue?vue&type=template&id=108b0fae&scoped=true"
import script from "./addSpecDlg.vue?vue&type=script&lang=js"
export * from "./addSpecDlg.vue?vue&type=script&lang=js"
import style0 from "./addSpecDlg.vue?vue&type=style&index=0&id=108b0fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108b0fae",
  null
  
)

export default component.exports